import React from 'react';
import { Table, Typography } from '@telus-uds/components-web';
import { useTranslation } from 'react-i18next';
import './PaymentSummary.css';

const PaymentSummary = ({ paymentItems, totalAmount }) => {
  const { t, i18n } = useTranslation();
  if (!paymentItems) return null;

  const taxItems = [];
  const lineItems = [];
  for (const item of paymentItems || []) {
    if (item.item['@referredType'] === 'Tax') taxItems.push(item);
    else lineItems.push(item);
  }

  return (
    <>
    <Table fullWidth text="medium">
      <Table.Header>
        <Table.Cell>
          <Typography variant={{ size: 'h3' }} tokens={{color: 'inherit'}}>
            {t('paymentSummary')}
          </Typography>
        </Table.Cell>
        <Table.Cell></Table.Cell>
      </Table.Header>

      <Table.Body>
        {lineItems.map((item, index) => (
          <Table.Row key={index}>
            <Table.Cell>
              <Typography variant={{ size: 'body' }} tag="div">
                {item.item.descriptionTranslations?.[i18n.language] || item.item.description}
              </Typography>
            </Table.Cell>
            <Table.Cell align="right">
              <Typography variant={{ size: 'body' }} tag="div">
                {`$${item.amount.value?.toFixed(2)}`}
              </Typography>
            </Table.Cell>
          </Table.Row>
        ))}
        </Table.Body>
    </Table>
    {
      taxItems.length ? (
        <Table fullWidth variant={{spacing: 'compact'}} tokens = {{cellPaddingTop: '3', cellPaddingBottom: '3'}}>
          <Table.Header>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Header>
          <Table.Body>
            {taxItems.map((item, index) => (
                <Table.Row key={index}>
                  <Table.Cell>
                    <Typography variant={{ size: 'small' }} tag="div">
                      {item.item.descriptionTranslations?.[i18n.language] || item.item.description}                    
                    </Typography>
                  </Table.Cell>
                  <Table.Cell align="right">
                    <Typography variant={{ size: 'small' }} tag="div">
                      {`$${item.amount.value?.toFixed(2)}`}
                    </Typography>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      ) : ''
    }
    <Table fullWidth variant={{spacing: 'compact'}}>
      <Table.Body>
        <Table.Row>
          <Table.Cell type="rowHeading">
            <Typography variant={{ size: 'large', colour: 'brand', bold: true }} tag="div">
              {t('total')}
            </Typography>
          </Table.Cell>
          <Table.Cell align="right">
            <Typography variant={{ size: 'large', colour: 'brand', bold: true }} tag="div">
              ${totalAmount.value?.toFixed(2)}
            </Typography>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    </>
  );
};

export default PaymentSummary;
